import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

const LoadingAnimation = () => {
  return <CircularProgress />
}

export default LoadingAnimation
